/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'

const Thumbnail = (props) => {
  const defaultThumbnail = (name) => {
    return (
      <div className={props.noImgClass}>
        <span className={props.noImgTextClass}>{name && name.trim().replace(/[^\w\s]/gi, '').charAt(0)}</span>
      </div>
    )
  }

  const defaultThumb = (name) => {
    let data = `<div class='${props.noImgClass}'><span class='${props.noImgTextClass}'>${name && name.trim().replace(/[^\w\s]/gi, '').charAt(0)}</span></div>`
    document.getElementById(props.divId).innerHTML = data
  }

  if (props.entityOverrideImage) {
    return (
      <div id={props.divId}>
        <span className={props.imageSpanClass}>
          <img className={props.imageClass} src={props.entityOverrideImage ? `data:image/jpeg;base64,${props.entityOverrideImage}` : '/static/images/homepageDieselLogo.png'} alt="anticipationImage" onError={(e)=>{e.target.style = 'display: none;'; defaultThumb(props.name);}} style={props.imageDivStyle}/>
        </span>
      </div>
    )
  }

  if (props.thumbnail && !props.entityOverrideImage) {
    return (
      <div id={props.divId}>
        <span className={props.imageSpanClass}>
          <img className={props.imageClass} src={props.thumbnail} alt="thumbnailImage" onError={(e)=>{e.target.style = 'display: none;'; defaultThumb(props.name);}} style={props.imageDivStyle}/>
        </span>
      </div>
    )
  }

  if (!props.thumbnail && !props.entityOverrideImage) {
    return defaultThumbnail(props.name)
  }
}
Thumbnail.propTypes = {
    color: PropTypes.string,
    entityOverrideImage: PropTypes.string,
    thumbnail: PropTypes.string,
    name: PropTypes.string,
    imageDivStyle: PropTypes.object,
    imageSpanClass: PropTypes.string,
    imageClass: PropTypes.string,
    noImgTextClass: PropTypes.string,
    noImgClass: PropTypes.string,
    divId: PropTypes.string
}

export default Thumbnail